import { Entity } from 'app/agriculture/queries/entities/types/Entity';
import { useGenericEntities } from 'app/agriculture/queries/entities/useGenericEntities';

export function useGenericEntity(entityId: string | number): Entity {
    const entities = useGenericEntities();
    const entity = entities.get(entityId);

    if (!entity) throw new Error(`Could not find entity for id: ${entityId}`);

    return entity;
}
